import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';

export const InctvRbtLineDetail = () => {
  const { entityObj } = useEntityMgr();

  const augInctvRbtFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntitySelect key="code" fieldDef={fieldToFieldDef.code} />;
  };

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'inctvRbt',
      label: 'Rebate',
      content: <EntityForm entity="INCTV_RBT" entityId={entityObj.inctvRbtId} augFieldDefs={augInctvRbtFieldDefs} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
